import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import VideoDrawer from '@blade/common/components/task-management/simple-drawer.vue';
import MapDarwer from './map-darwer.vue';
import { MapPolygonsModule } from '@blade-sxp/task-management/store/mapPolygons';
import { setCustomOptions } from '@blade-sxp/task-management/constant/drawer-options';
import { isEmpty } from 'lodash';
let DrawRoiMap = class DrawRoiMap extends Vue {
    visible;
    polygons;
    rtspAddress;
    zoneId;
    uncheckedImg = require('@blade-sxp/task-management/assets/subtract.png');
    selectImg = require('@blade-sxp/task-management/assets/select.png');
    drawedImg = require('@blade-sxp/task-management/assets/light.png');
    noDrawedImg = require('@blade-sxp/task-management/assets/hide.png');
    isPlay = true;
    dialogVisible = false;
    limits = {};
    drawButtons = ['polygon', 'rect'];
    paintState = false;
    styleProp = {
        width: 434,
        height: 240
    };
    mapStyleProp = {
        width: 680,
        height: 510
    };
    options = setCustomOptions('polygon');
    localPolygons = [];
    mapPolygons = [];
    selectActive = -1;
    mapDrawState = false;
    mapId = '';
    mapSource = MapPolygonsModule.mapPolygonMap;
    showPoints = true;
    onchangePolygons(val) {
        if (val) {
            let data;
            if (this.polygons) {
                data = val.map((item) => {
                    return {
                        ...item,
                        statusImg: this.uncheckedImg,
                        drawerStatus: false
                    };
                });
                this.localPolygons = data;
                if (!isEmpty(this.mapSource) && !isEmpty(this.localPolygons)) {
                    this.mapSource.forEach((it, key) => {
                        this.localPolygons.forEach((item, index) => {
                            if (String(item.id) === String(key)) {
                                this.localPolygons[index].statusImg = this.selectImg;
                                this.localPolygons[index].drawerStatus = true;
                            }
                        });
                    });
                }
            }
        }
    }
    onchangeLocalPolygons(val) {
        if (val) {
            this.mapDrawState = val.every((item) => {
                return item.drawerStatus === true;
            });
        }
    }
    onChangeStatus(val) {
        this.dialogVisible = val;
    }
    selectChange(index, mapId) {
        this.mapId = mapId;
        if (this.selectActive === index) {
            this.selectActive = -1;
            this.paintState = false;
        }
        else {
            this.paintState = true;
            this.selectActive = index;
            if (this.localPolygons[index].drawerStatus) {
                const param = {
                    mapId,
                    reovemId: this.taskId() + mapId
                };
                MapPolygonsModule.removeMapPolygonMap(param);
                this.localPolygons[index].drawerStatus = false;
                this.localPolygons[index].statusImg = this.uncheckedImg;
            }
        }
    }
    taskId() {
        const num = Math.random() * 100000;
        return Math.round(num);
    }
    handleDrawEnd() {
    }
    mapDrawEnd(val) {
        if (this.localPolygons) {
            this.localPolygons.forEach((item, index) => {
                if (val.status) {
                    if (index === this.selectActive) {
                        item.statusImg = this.selectImg;
                        item.drawerStatus = true;
                        this.mapDrawState = true;
                        this.selectActive = -1;
                        this.paintState = false;
                    }
                }
                else {
                    if (index === this.selectActive) {
                        item.statusImg = this.uncheckedImg;
                        item.drawerStatus = false;
                        this.mapDrawState = false;
                        this.selectActive = -1;
                        this.paintState = false;
                    }
                }
            });
        }
    }
    mapDrawerOver() {
        MapPolygonsModule.saveMapData();
        this.dialogVisible = false;
        this.$emit('map-roi', true);
    }
    mapDialogClose() {
        MapPolygonsModule.clearMapPolygonMap();
        this.dialogVisible = false;
        this.$emit('close', this.dialogVisible);
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], DrawRoiMap.prototype, "visible", void 0);
__decorate([
    Prop({})
], DrawRoiMap.prototype, "polygons", void 0);
__decorate([
    Prop()
], DrawRoiMap.prototype, "rtspAddress", void 0);
__decorate([
    Prop()
], DrawRoiMap.prototype, "zoneId", void 0);
__decorate([
    Watch('polygons', { immediate: true, deep: true })
], DrawRoiMap.prototype, "onchangePolygons", null);
__decorate([
    Watch('localPolygons', { immediate: true, deep: true })
], DrawRoiMap.prototype, "onchangeLocalPolygons", null);
__decorate([
    Watch('visible', { immediate: true })
], DrawRoiMap.prototype, "onChangeStatus", null);
DrawRoiMap = __decorate([
    Component({
        name: 'DrawRoiMap',
        components: {
            'st-video-drawer': VideoDrawer,
            'st-map-darwer': MapDarwer
        },
        i18n: {
            messages: {
                en: {
                    roiArea: 'ROI Area',
                    drawRoiMap: 'Draw ROI On Map',
                    cancel: 'Cancel',
                    submit: 'Submit',
                    mapTip: "this ROI area haven't drawn in map",
                },
                zh: {
                    roiArea: 'ROI 区域',
                    drawRoiMap: '在地图上画ROI',
                    cancel: '取消',
                    submit: '提交',
                    mapTip: '这个ROI区域还没有绘制在地图上',
                }
            }
        }
    })
], DrawRoiMap);
export default DrawRoiMap;
